import { useMemo } from 'react';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { EventPageSection } from 'src/modules/events/models/eventPage';
import { StickyMenu, StickyMenuProps } from 'src/components/common/StickyMenu';
import { useFlattenEvent } from 'src/modules/events/hooks/useFlattenEvent';
import { Events } from 'src/graphql/schema.graphql';

export interface EventPageStickyMenuProps
  extends Pick<StickyMenuProps, 'bannerHeight'> {
  event: Events;
}

const stickyMenuSections = [
  { id: EventPageSection.About, label: 'ABOUT' },
  { id: EventPageSection.Agenda, label: 'agenda' },
  { id: EventPageSection.Speakers, label: 'speakers' },
  { id: EventPageSection.RelatedVideos, label: 'videos' },
  { id: EventPageSection.FAQ, label: 'faq' },
];

const StyledStickyMenu = styled(StickyMenu)`
  &&& {
    .sticky-menu__button {
      justify-content: start;
      min-width: 116px;
      ${media.w.greaterThanOrEqual.desktop} {
        min-width: 170px;
      }
    }
  }
`;

export const EventPageStickyMenu = ({
  event,
  ...props
}: EventPageStickyMenuProps) => {
  const flatEvent = useFlattenEvent(event);

  const filteredStickyMenuSections = useMemo(
    () =>
      stickyMenuSections.filter(({ id }) => {
        if (id === EventPageSection.Speakers) {
          return flatEvent.speakers.length > 0;
        }
        if (id === EventPageSection.Agenda) {
          return !!flatEvent.subEvents?.length;
        }
        if (id === EventPageSection.FAQ) {
          return flatEvent.faq?.length > 0;
        }
        if (id === EventPageSection.RelatedVideos) {
          return flatEvent.tags?.length > 0;
        }

        return true;
      }),
    [flatEvent],
  );

  return (
    <StyledStickyMenu
      tabs={filteredStickyMenuSections}
      transparentOnTop
      {...props}
    />
  );
};
